import { render, staticRenderFns } from "./ChatMessageItem.vue?vue&type=template&id=3617da10&scoped=true&"
import script from "./ChatMessageItem.vue?vue&type=script&lang=js&"
export * from "./ChatMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageItem.vue?vue&type=style&index=0&id=3617da10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617da10",
  null
  
)

export default component.exports